<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
        Detect Detail
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WSFinder</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Detect</a>
        </li>
        </ul>
      </div>
      <b-row>
        <b-col lg="12" xl="12">
          <b-card>
            <div class="d-flex flex-wrap align-items-center">
              <div class="title mr-auto mb7">
                Detect Info
              </div>
              <div class="mb7">
                <span class="float-right" style="font-size: 13px">Detect Time : {{model.created_at | datetime}}</span>
              </div>
            </div>
            <hr>
            <b-row class="mb-2">
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                <label class="col-form-label" for="ph_agent" v-b-tooltip.hover title="Agent">Agent</label><br>
              </b-col>
              <b-col class="col-xl-10 col-md-12  d-flex align-self-center">
                <label for="ph_agent" v-if="model.agent">{{`${model.agent.name} (${model.agent.host}@${model.agent.ip_addr})`}}</label>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                <label class="col-form-label" for="ph_path" v-b-tooltip.hover title="Path">Path</label><br>
              </b-col>
              <b-col class="col-xl-10 col-md-12">
                <label for="ph_path" style="width:100%; background-color:#f5f5f5; border:1px solid #ccc; padding:10px; border-radius: 5px;">{{model.path | truncate(100)}}</label>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                <label class="col-form-label" for="ph_category" v-b-tooltip.hover title="Category">Category</label><br>
              </b-col>
              <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
                <label for="ph_category" v-if="model && model.category">{{model.category}}</label>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model">
                <label class="col-form-label" for="ph_ext" v-b-tooltip.hover title="Value">Value</label><br>
              </b-col>
              <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
                <label for="ph_ext" v-if="model && model.description">{{model.description.value || 'None'}}</label>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model">
                <label class="col-form-label" for="ph_is_backup" v-b-tooltip.hover title="Backup Mode">Backup Mode</label><br>
              </b-col>
              <b-col class="col-xl-4 col-md-12 align-self-center">
                <b-badge :variant="model.is_backup ? 'success' : 'secondary'">{{model.is_backup ? 'On' : 'Off'}}</b-badge>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                <label class="col-form-label" for="ph_type" v-b-tooltip.hover title="Type">Type</label><br>
              </b-col>
              <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
                <label for="ph_type" v-if="model.description && model.description.type">{{model.description.type ? model.description.type : codes.code_type[model.type] }}</label>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                <label class="col-form-label" for="ph_code" v-b-tooltip.hover title="Code">Code</label><br>
              </b-col>
              <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
                <label for="ph_code" v-if="model.description">{{model.description.code || 'undefined'}}</label>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model && model.description && model.description.type != 'md5'">
                <label class="col-form-label" for="ph_numerical" v-b-tooltip.hover title="Line">Line</label><br>
              </b-col>
              <b-col class="col-xl-4 col-md-12  d-flex align-self-center" v-if="model && model.description && model.description.type != 'md5'">
                <label for="ph_numerical"> {{model.description.numerical}}</label>
              </b-col>
            </b-row>
            <b-button size="sm" class="float-right text-white btn btn-addition" @click="list"> List </b-button>
          </b-card>
        </b-col>
      </b-row>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>